import React from 'react';
import style from './RectButton.module.scss';

// if path is passed, renders a link (which can also take a click handler)
// If no path, it renders a button
const RectButton = ({ path, buttonText, externalLink, handleClick }) =>
  path ? (
    <a
      href={path}
      className={`chapter-button ${style.rectButton}`}
      target={externalLink ? '_blank' : ''}
      rel={externalLink ? 'noopener' : ''}
      onClick={handleClick ? handleClick : () => {}}
    >
      {buttonText}
    </a>
  ) : (
    <button
      className={`chapter-button ${style.rectButton}`}
      onClick={handleClick}
    >
      {buttonText}
    </button>
  );

export default RectButton;



// WEBPACK FOOTER //
// ./src/components/ui/RectButton.js